import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSchedule from './schedule.reducer';

export const selectScheduleState = createFeatureSelector<fromSchedule.SchedulesState>(fromSchedule.scheduleFeatureKey);

export const selectSchedules = createSelector(selectScheduleState, (state) => {
  return (state.schedules ?? []).map((s) => {
    s.frequencyText = s.frequencyText?.replace('Monday,Tuesday,Wednesday,Thursday,Friday', 'weekday');
    return s;
  });
});
export const selectSchedulesPagination = createSelector(selectScheduleState, (state) => state.pagination);
export const selectSchedulesQuery = createSelector(selectScheduleState, (state) => state.query);
export const selectSchedulesFilters = createSelector(selectScheduleState, (state) => state.filters);
export const selectSchedulesSort = createSelector(selectScheduleState, (state) => state.sort);
export const selectIsLoading = createSelector(selectScheduleState, (state) => state.isLoading);
export const selectHasDeletedSchedules = createSelector(selectScheduleState, (state) => state.hasDeletedSchedules);
export const selectAvailableIntervals = createSelector(selectScheduleState, (state) => state.availableIntervals);
export const selectMinimumScheduleInterval = createSelector(
  selectScheduleState,
  (state) => state.minimumScheduleInterval
);
